import { createSlice } from "@reduxjs/toolkit";

const initialZatcaState = {
  listLoading: false,
  actionsLoading: false,
  error: null,
  zatcaLogs: [],
  totalLogsCount: 0,
  allLogsCount: 0,
};

export const callTypes = {
  list: "list",
  action: "action",
};
export const zatcaSlice = createSlice({
  name: "zatca",
  initialState: initialZatcaState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.navigate = false;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    getZatcaOnboardingLogs: (state, action) => {
      const { logs, totalCount, allLogsCount } = action.payload;
      state.error = null;
      state.zatcaLogs = logs;
      state.totalLogsCount = totalCount;
      state.allLogsCount = allLogsCount;
    },
  },
});
